import * as React from "react";
import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { HttpContext } from "../api-services/HttpService";
import DashboardLinks from "../assets/dashboardLinks.json";
import RecentRecordLinks from "../assets/recentRecordLinks.json";

const RecentLinkContext = createContext();

const skipUrlsMap = new Map([
  ["/PayoutSchedulePage", process.env.REACT_APP_REBATE_PAYOUT_SCHEDULER],
  ["/SearchClientContractPage", process.env.REACT_APP_UPLOAD_CLIENT_CONTRACTS],
  ["/AddConsortiumIdPage", process.env.REACT_APP_CONSORTIUM_MANAGEMENT]
]);
/**
 This route is used for saving all the information related to
 the recent links feature. Every path call to the component in the
 app.js will make a post call to save the data in the db. These will
 further be retrieved in the offcanvas in MyDashboard component.
 Based on dashboardLinks and recentRecordLinks configuration, data
 is posted.
 */
const RecentLinksRoute = (props) => {
  const { POST } = useContext(HttpContext);

  const location = useLocation();
  const backPath = useSelector((state) => state.backPath);
  const company = useSelector((state) => state.company);
  const companyInfo = useSelector((state) => state.companyInfo);
  const transactionDetails = useSelector((state) => state.transactionDetails);
  const consortiumId = useSelector((state) => state.consortiumId);
  const path = location.pathname;
  const settings = {
    path,
  };

//call the post api call for saving the recent links to db
  const postRecentLinks = () => {
    const currentPath = location.pathname;
    if (!(skipUrlsMap.has(currentPath) && skipUrlsMap.get(currentPath) !== '1') || DashboardLinks.data.includes(currentPath)) {
      return new Promise((resolve, reject) => {
        let params = {};
        params.path = currentPath;
         if (RecentRecordLinks[currentPath].hasCompany && company) {
          params.company = company;
        }
        if (RecentRecordLinks[currentPath].hasCompanyInfo && companyInfo) {
          params.mastercompanyid = companyInfo?.mastercompanyid;
          params.companyinfo = companyInfo;
        }
        if (RecentRecordLinks[currentPath].hasBackPath && backPath) {
          params.backpath = backPath;
        }
        if (
          RecentRecordLinks[currentPath].hasTransactionDetails &&
          transactionDetails
        ) {
          params.transactiondetails = transactionDetails;
        }
        if (RecentRecordLinks[currentPath].hasConsortiumId && consortiumId) {
          params.consortiumid = consortiumId;
        }
        let recentRecord = { recentRecord: params };
        POST("/links/recent", recentRecord)
          .then((res) => {
            console.log(res);
          })
          .then((res) => {
            // resolve on success
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    }
  };

  //use effect is invoked as and when the path is changed
  useEffect(() => {
    postRecentLinks();
  }, [location]);

  return (
    // wrap all children in auth context
    <RecentLinkContext.Provider value={settings}>
      {/* <Routes> */}
      {props.children}
      {/* </Routes> */}
    </RecentLinkContext.Provider>
  );
};
export default RecentLinksRoute;
